import { render, staticRenderFns } from "./SegmentsPage.vue?vue&type=template&id=6d6bb906&scoped=true&"
import script from "./SegmentsPage.vue?vue&type=script&lang=js&"
export * from "./SegmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsPage.vue?vue&type=style&index=0&id=6d6bb906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6bb906",
  null
  
)

export default component.exports